import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
//import { InterventionsPdfService } from '../../services/interventions-pdf.service';
import { StockService } from '@app/shared/services/entities/stock.service';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('CANCEL-DIALOG COMPONENT')

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-interventions-cancel-dialog',
  templateUrl: './interventions-cancel-dialog.component.html',
  styleUrls: ['./interventions-cancel-dialog.component.scss'],
})
export class CancelDialog {

  public interventionForm: FormGroup;

  public record = null;

  public doctorObject = null;
  public procedureObject = null;
  public specialtyObject = null;

  public itemList = [];
  public delivery = [];

  public cancelOptions = [
  'Hipertension arterial del paciente',
  'Consumo de alimentos',
  'Valoracion preoperatoria',
  'Paciente descompensado',
  'Reserva de cama',
  'Disponibilidad de material e insumos',
  'Reserva de sangre y/o plaquetas',
  'Consentimento informado',
  'Suspensión de anticoagulantes',
  'Consumo de medicamentos',
  'No se presento el paciente',
  'No candidato a intervención quirúrgica',
  'Defunción',
  'Error del médico',
  'No paso valoración de anestesiología',
  'Falta de tiempo quirúrgico',
  'Solo se utilizo el equipo',
  'Se duplico la solicitud',
  'Cambia médico tratante',
  'Paciente foráneo',
  'Fallo de equipo biomédico',
  'Alta del paciente',
  'Reprogramado'
];

  constructor(
    private formBuilder: FormBuilder,
    private customMessageService: CustomMessageService,
    private interventionsService: InterventionsService,
    private inventoryService: StockService,
    @Inject(MAT_DIALOG_DATA) public data:  any ,
    public dialogRef: MatDialogRef<CancelDialog>
  ) { }

  async ngOnInit(){
    //log.debug(this.data)
    this.record = this.data['record'];
    this.doctorObject = this.data['doctor'];
    this.specialtyObject = this.data['specialty'];
    this.procedureObject = this.data['procedure'];

    this.interventionForm = this.formBuilder.group({
      cancel: [null, Validators.required],
    });
  }

    /*** @description Da formato a fecha*/
    public formatDate(dateString: string): string {
      const testDate = new Date(dateString);
      return testDate.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
    }

    /**
   * @description Edición de intervención
   */
    async pacthInterventions(data) {
      this.customMessageService.open({
        title: 'Espere',
        type: 'neutral',
        message: 'Editando programación quirúrgica',
        duration: 2000,
        loading: true,
      });
      if (this.interventionForm.status == 'INVALID') {
        this.customMessageService.open({
          title: 'Información',
          type: 'neutral',
          message:
            'Por favor completa todos los campos del registro para editar la programación quirúrgica.',
          dismissBtn: true,
        });
        return;
      }
      data['modifiedBy'] = sessionStorage.getItem('userId');
      let apiResponse = await this.interventionsService.update(data);
      //log.debug(apiResponse);
      if (apiResponse['state'] == 'success') {
        await this.customMessageService.open({
          title: '¡Hecho!',
          type: 'success',
          message: apiResponse['message'],
          duration: 2000,
        });
        return apiResponse['data'][0];
      } else {
        await this.customMessageService.open({
          title: 'Error',
          type: 'error',
          message: apiResponse['message'],
          duration: 2000,
        });
      }
    }

    async changeProductStatus(data: any, status: string){
      try{
        let updated = [];
        //log.debug(data)
        this.customMessageService.open({title: 'Espere', type: 'success', message: `Actualizando estatus de insumos...`, loading: true });
        for await (const item of data) {
          let itemToUpdate = {
            id: item['id'],
            tagRfid: item['tagRfid'],
            status: status
          }
          //log.debug(itemToUpdate);
          let apiResponse = await this.inventoryService.update(itemToUpdate);
          //log.debug(apiResponse)
          this.customMessageService.close()
          if (apiResponse['state'] == 'success') {
            let row = apiResponse['data'][0];
            updated.push(row);
          }else{
            await this.customMessageService.open({title: 'Error', type: apiResponse['state'], message: apiResponse['message'], dismissBtn: true });
          }
        }
        this.customMessageService.close();
        if(updated.length > 0){
          await this.customMessageService.open({title: '¡Hecho!', type: 'success', message: 'Insumos actualizados correctamente', duration: 3000 });
        }
      }catch(err){
        this.customMessageService.close();
        await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
      }
    }

      /**
   * @description Busqueda de producto por Id
   */
   async getItemById(id: any){
    try {
      this.customMessageService.open({ title: "Espere",type: 'success', message: 'Buscando entregas', duration: 2000, loading: true });
      let apiResponse = await this.inventoryService.search({id: id});
      //log.debug(apiResponse)
      if(apiResponse['state'] == 'success' && apiResponse['data'][0] != null){
        let items = apiResponse['data'][0]

        //log.debug(items)
        this.delivery.push(items)
        this.customMessageService.close();
      }else if(apiResponse['data'][0] == null){
        await this.customMessageService.open({title: "Espere",type: 'error', message: 'Etiqueta RFID no encontrado', dismissBtn: true });
      }
    }
    catch(err) {
      await this.customMessageService.open({title: "Espere",type: 'error', message: 'Error al cargar datos', dismissBtn: true });
    }
  }

    async save(){
      let data = this.interventionForm.value;

      data['id'] = this.record['id'];
      data['status'] = 'Cancelada'


      
      if(this.record['delivery'] != null && this.record['delivery'].length>0){
        for await (const item of this.record['delivery']) {
          await this.getItemById(item);
        }
      }
      if(this.delivery.length>0) await this.changeProductStatus([...this.delivery], 'Disponible');
      let intervention = await this.pacthInterventions(data);
      if(!intervention) return;
      this.dialogRef.close(intervention);
  
    }

}
